
import param from '~/utils/url/param.js'
export default {
  name: 'social-twitter',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' }
  },
  methods: {
    open() {
      window.open(
        'https://www.twitter.com/share' +
          param({ url: this.url, text: this.title }),
        '__blank'
      )
    }
  }
}
